export const UpdateSystem = {
  data() {
    return {
      refreshing: false, // prevent loop reload
      // registration not needed here because we get it when we need it
    }
  },
  
  methods: {
    // 1. the function that breaks the cache with a random number (like we agreed)
    breakCache() {
      const url = new URL(window.location.origin);
      url.searchParams.set('v', new Date().getTime());
      window.location.href = url.toString();
    },

    // 2. the function that connects to the "Update Now" button in the pop-up of your app
    async updateNow() {
       // helper function to clear the cache and reload the page
      const forceReload = () => {
        if ('caches' in window) {
          // clear the cache first
          caches.keys().then(names => Promise.all(names.map(n => caches.delete(n))));
        }
        this.$nextTick(() => {
          this.breakCache();
        });
      };
    
      try {
        const reg = this.registration || await navigator.serviceWorker.getRegistration();
    
        // 1. the state where we found: if the files are not loading in the background
        if (reg && reg.installing) {
          reg.unregister(); 
          return forceReload(); // call the function by its original name
        }
    
        // 2. the ideal state: if the files have finished loading and are ready
        if (reg && reg.waiting) {
          navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (this.refreshing) return;
            this.refreshing = true;
            
            this.$nextTick(() => {
              this.breakCache();
            });
          }, { once: true });
    
          reg.waiting.postMessage({ type: 'SKIP_WAITING' });
          
          // additional protection if the reload is not done
          setTimeout(forceReload, 2000);
          return;
        }
    
        // 3. if there is no update in the PWA at all
        forceReload();
    
      } catch (e) {
        console.error("SW Error:", e);
        forceReload();
      }
    }
  }
};